import { JsonObject, JsonProperty } from 'json2typescript';
import { SearchResults } from '../searchResults';
import { ProtectionClub } from './protectionClub';

@JsonObject('ClubSearchResults')
export class ClubSearchResults extends SearchResults {
    @JsonProperty('results', [ProtectionClub])
    results: ProtectionClub[] = [];
}
